<template>
  <div class="page">
    <div class="v1">
      <div class="v1-1">
        <img
          src="~@/assets/images/active/active20230721/10.png"
          alt=""
          @click="showShareDialog = true"
        />
        <span>分享</span>
      </div>
    </div>
    <div class="v2">
      <div class="v2-bg">
        <div class="v2-1 flex">
          <div class="v2-1-1">推荐客户</div>
        </div>
        <div class="v2-2">
          <div class="v2-2-1">客户要求</div>
          <div class="v2-2-2 flex flex-between">
            <div
              v-for="(item, index) in demandList"
              :key="index"
              :class="{ active: item.checked }"
              class="v2-2-2-1"
              @click="onSelectDemand(item)"
            >
              {{ item.name }}
            </div>
          </div>
        </div>

        <div class="v2-3">
          <div class="v2-3-1">
            <Field v-model="form.customerName" placeholder="请输入公司名称" />
          </div>
          <div class="v2-3-1">
            <Field
              v-model="form.customerPerson"
              placeholder="请输入联系人姓名"
            />
          </div>
          <div class="v2-3-1">
            <Field
              v-model="form.customerPhone"
              placeholder="请输入联系人手机号"
            />
          </div>
        </div>

        <div class="v2-4">
          <div class="v2-4-1">
            <Button block round color="#FF423F" @click="onSubmit">提 交</Button>
          </div>
          <div class="v2-4-2">
            <span @click="toRecord">推荐记录</span>
          </div>
        </div>
      </div>
    </div>

    <div class="v3">
      <img
        class="v3-bg"
        src="~@/assets/images/active/active20230721/6.png"
        alt=""
      />
      <div class="v3-btn">
        <a href="https://www.shenzhoubb.com/m/index.html">了解更多</a>
      </div>
    </div>

    <div class="v3">
      <img
        class="v3-bg"
        src="~@/assets/images/active/active20230721/2.png"
        alt=""
      />
    </div>

    <div class="v3">
      <img
        class="v3-bg"
        src="~@/assets/images/active/active20230721/3.png"
        alt=""
      />
    </div>

    <div class="v2 video">
      <video-player
        class="video-player-box play"
        ref="videoPlayer"
        :options="playerOptions"
        :playsinline="true"
      >
      </video-player>
    </div>

    <div class="v3">
      <img
        class="v3-bg"
        src="~@/assets/images/active/active20230721/4.png"
        alt=""
      />
    </div>

    <div class="v3">
      <img
        class="v3-bg"
        src="~@/assets/images/active/active20230721/9.png"
        alt=""
      />
    </div>

    <div class="v4 flex">
      <div class="v4-1">本活动最终解释权归神州邦邦所有</div>
    </div>

    <div v-show="showShareDialog" class="v8">
      <div class="v8-1">
        <div class="v8-1-1 share_bt">
          <div class="v8-1-1__t">分享给朋友</div>
          <div class="v8-1-1__t2">分享的不是赚钱的机会，是义气</div>
        </div>
        <div class="v8-1-1" @click="toCustomer">
          <div class="v8-1-1__t">分享给客户</div>
          <div class="v8-1-1__t2">
            该页面将隐藏活动参与信息，客户更快速了解需求
          </div>
        </div>
      </div>

      <div class="v8-2">
        <Icon
          name="close"
          color="#fff"
          size="0.52rem"
          @click="showShareDialog = false"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { Toast, Dialog, Field, Button, Icon } from "vant";
import { post } from "@/utils/request";
import { h5, api } from "@/utils/env";
import { initShare, initLogin } from "@/utils";
import "video.js/dist/video-js.css";
import { videoPlayer } from "vue-video-player";
export default {
  components: {
    Icon,
    Field,
    Button,
    videoPlayer,
  },
  data() {
    return {
      form: {
        customerName: "",
        customerPerson: "",
        customerPhone: "",
        customerDemand: [],
      },
      demandList: [
        {
          name: "笔记本",
          checked: false,
        },
        {
          name: "台式机",
          checked: false,
        },
        {
          name: "其他",
          checked: false,
        },
      ],
      playerOptions: {
        // videojs options
        autoplay: true,
        muted: true,
        language: "zh-CN",
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        sources: [
          {
            type: "video/mp4",
            src: "https://images-public.shenzhoubb.com/corp/bearrental-u.mp4",
          },
        ],
        poster: "",
      },
      initShareObg: {},
      showShareDialog: false,
    };
  },
  computed: {},
  mounted() {
    this.initShareObg = new initShare({
      shareUrl: `${h5}app/v2/active/20221103-main.html`,
      sharePath: "commonh5",
      imgUrl: "https://static.shenzhoubb.com/images/miniapp/20230721share.jpg",
      miniAppImgUrl:
        "https://static.shenzhoubb.com/images/miniapp/20230721share2.jpg",
      title: "【邦租赁&小熊U租】",
      desc: "推荐客户领现金奖励，一起来参与吧！",
    });
  },
  methods: {
    onSelectDemand(item) {
      item.checked = !item.checked;
      this.form.customerDemand = this.demandList
        .filter((item) => item.checked)
        .map((item) => item.name);
    },
    onSuccess() {
      Dialog.confirm({
        title: "提交成功",
        message:
          "稍后客服将联系客户，请确认所填企业信息与联系人方式，真实有效！",
        confirmButtonText: "查看记录",
        cancelButtonText: "关闭",
      })
        .then(() => {
          // on confirm
          this.$router.push({
            path: "/20230721-record.html",
          });
        })
        .catch(() => {
          // on cancel
          this.form = {
            customerName: "",
            customerPerson: "",
            customerPhone: "",
            customerDemand: [],
          };
          this.demandList = this.demandList.map((item) => {
            item.checked = false;
            return item;
          });
        });
    },
    onSubmit() {
      if (this.form.customerDemand.length === 0) {
        Toast("请选择客户需求");
        return;
      }
      if (!this.form.customerName) {
        Toast("请输入公司名称");
        return;
      }
      if (!this.form.customerPerson) {
        Toast("请输入联系人姓名");
        return;
      }
      const phoneReg = /^(?:(?:\+|00)86)?1\d{10}$/;
      if (!phoneReg.test(this.form.customerPhone)) {
        Toast("请输入正确的联系人手机号");
        return;
      }
      initLogin({
        scope: "snsapi_base",
        success: () => {
          post({
            url: api + "thirdBusinessOp/submit",
            requestType: 1,
            data: {
              ...this.form,
              source: "推荐人",
            },
          })
            .then((res) => {
              if (res.result === "success") {
                this.onSuccess();
                return;
              }
              Toast(res.message);
            })
            .catch(() => {});
        },
      });
    },
    toRecord() {
      initLogin({
        scope: "snsapi_base",
        success: () => {
          this.$router.push({
            path: "/20230721-record.html",
          });
        },
      });
    },
    toCustomer() {
      this.$router.push({
        path: "/20230721-customer.html",
      });
      this.showShareDialog = false;
    },
  },
};
</script>

<style lang="less" scoped>
.page {
  position: relative;
  background: url(~@/assets/images/active/active20230721/1.png) no-repeat;
  background-size: 100% auto;
  background-position: top center;
  background-color: #cb293c;
}

.flex {
  display: flex;
  align-items: center;

  &-between {
    justify-content: space-between;
  }
}

.v1 {
  position: relative;
  height: 8.3rem;

  .v1-1 {
    position: absolute;
    top: 0.36rem;
    right: 0.3rem;
    z-index: 1;
    display: flex;
    align-items: center;

    img {
      display: block;
      width: 0.4rem;
      height: 0.4rem;
      margin-right: 0.08rem;
    }
    span {
      font-size: 0.28rem;
      color: #fff;
    }
  }
}

.v2 {
  box-sizing: border-box;
  width: 6.9rem;
  margin: 0 auto;
  padding: 0.24rem 0.2rem;
  background: rgba(255, 255, 255, 0.3);
  border-radius: 0.16rem;
  border: 0.02rem solid #ffffff;
  backdrop-filter: blur(0.09rem);

  &-bg {
    width: 100%;
    background: linear-gradient(180deg, #fefbf5 0%, #fcf5e8 100%);
    border-radius: 0.16rem;
    backdrop-filter: blur(0rem);
  }

  .v2-1 {
    justify-content: center;

    .v2-1-1 {
      width: 2.54rem;
      padding: 0.16rem 0;
      text-align: center;
      font-size: 0.28rem;
      font-weight: 600;
      color: #ffffff;
      line-height: 0.28rem;
      background: #ff423f;
      border-radius: 0rem 0rem 0.26rem 0.26rem;
    }
  }

  .v2-2 {
    box-sizing: border-box;
    margin: 0.32rem 0;
    padding: 0 0.34rem;
  }

  .v2-2-1 {
    margin-bottom: 0.2rem;
    font-size: 0.28rem;
    font-weight: 400;
    color: #97250d;
    line-height: 0.36rem;
  }

  .v2-2-2 {
    .v2-2-2-1 {
      box-sizing: border-box;
      width: 1.8rem;
      padding: 0.12rem 0;
      text-align: center;
      font-size: 0.28rem;
      font-weight: 400;
      color: #9b2d16;
      line-height: 0.32rem;
      border-radius: 0.36rem;
      border: 0.02rem solid #d7aba1;
    }

    .active {
      color: #fff;
      background: #ff423f;
      border: 0.02rem solid #ff423f;
    }
  }

  .v2-3 {
    padding: 0 0.3rem;
  }

  .v2-3-1 {
    width: 100%;
    margin-bottom: 0.16rem;
    background: transparent;
    border: 0.02rem solid #dcb6af;
    border-radius: 0.02rem;
    overflow: hidden;

    .van-cell {
      padding: 0.14rem 0.22rem;
      background: transparent;
    }

    ::-webkit-input-placeholder {
      color: #97250d;
    }
    ::-moz-placeholder {
      color: #97250d;
    }
    :-ms-input-placeholder {
      color: #97250d;
    }
  }

  .v2-4 {
    padding: 0 0.3rem;
  }

  .v2-4-1 {
    width: 100%;
    margin-top: 0.32rem;

    .van-button--normal {
      font-size: 0.32rem;
      height: 0.7rem;
    }
  }

  .v2-4-2 {
    box-sizing: border-box;
    padding: 0.32rem 0;
    text-align: center;
    font-size: 0;

    span {
      font-size: 0.24rem;
      font-weight: 400;
      color: #ff423f;
      line-height: 0.36rem;
    }
  }
}

.v3 {
  position: relative;
  margin-top: 0.2rem;

  &-bg {
    display: block;
    width: 6.9rem;
    margin: 0 auto;
  }

  .v3-btn {
    position: absolute;
    top: 1.86rem;
    left: 3.22rem;

    a {
      display: block;
      padding: 0.08rem 0.32rem;
      font-size: 0.22rem;
      color: #ffffff;
      line-height: 0.32rem;
      background: #ff423f;
      border-radius: 0.36rem;
      border: 0.02rem solid #ff423f;
    }
  }
}

.v4 {
  justify-content: center;

  .v4-1 {
    box-sizing: border-box;
    position: relative;
    padding: 0.2rem 0 0.24rem;
    font-size: 0.24rem;
    font-family: AlibabaPuHuiTi-Regular, AlibabaPuHuiTi;
    font-weight: 400;
    color: rgba(255, 255, 255, 0.69);
    line-height: 0.48rem;

    &::before,
    &::after {
      content: " ";
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      z-index: 1;
      width: 0.5rem;
      border-top: 0.02rem solid rgba(255, 255, 255, 0.36);
    }

    &::before {
      left: -0.6rem;
    }

    &::after {
      right: -0.6rem;
    }
  }
}

.video {
  margin-top: 0.2rem;

  .play {
    width: 100%;
    height: 3.63rem;
    margin: 0 auto;
  }

  /deep/ .video-js {
    width: 100%;
    height: 100%;
  }
}

.v8 {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  background: rgba(0, 0, 0, 0.8);

  .v8-1 {
    width: 6.26rem;
    margin: 3rem auto 0.54rem;
    background: #ffffff;
    border-radius: 0.32rem;
  }

  .v8-1-1 {
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    justify-content: center;
    height: 1.58rem;
    padding: 0 0.66rem;

    &:not(:last-child) {
      position: relative;

      &::after {
        content: " ";
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        border-bottom: 1px solid #eeeeee;
      }
    }
  }

  .v8-1-1__t {
    font-size: 0.28rem;
    color: #353232;
    line-height: 0.4rem;
  }

  .v8-1-1__t2 {
    margin-top: 0.1rem;
    font-size: 0.22rem;
    color: #948e8e;
    line-height: 0.32rem;
  }

  .v8-2 {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
  }
}
</style>